export default function addStylesToDOM(url, attributes = {}) {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link');

        link.setAttribute('href', url);
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');

        // Set all given attributes
        Object.keys(attributes).forEach((key) => {
            link.setAttribute(key, attributes[key]);
        });

        // Set promise callbacks
        link.onload = resolve;
        link.onerror = reject;

        document.head.appendChild(link);
    });
}
